/* POLARIS theme — interactions, no dependencies */
(function () {
  "use strict";

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll("[data-reveal]");
  if (reveals.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = (e.target.dataset.revealDelay || "0") + "ms";
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---- Mobile menu drawer ---- */
  var menu = document.querySelector("[data-mobile-menu]");
  if (menu) {
    function openMenu() { menu.classList.add("is-open"); document.body.classList.add("menu-open"); }
    function closeMenu() { menu.classList.remove("is-open"); document.body.classList.remove("menu-open"); }
    document.querySelectorAll("[data-menu-open]").forEach(function (b) { b.addEventListener("click", openMenu); });
    document.querySelectorAll("[data-menu-close]").forEach(function (b) { b.addEventListener("click", closeMenu); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
  }

  /* ---- Product gallery: thumbs, arrows, zoom ---- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    var idx = 0;
    function setActive(i) {
      if (!thumbs.length || !main) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      var src = t.dataset.full || (t.querySelector("img") && t.querySelector("img").src);
      if (src) main.src = src;
      thumbs.forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
      t.scrollIntoView({ inline: "nearest", block: "nearest" });
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { setActive(i); }); });
    var prev = gallery.querySelector("[data-gallery-prev]");
    var next = gallery.querySelector("[data-gallery-next]");
    if (prev) prev.addEventListener("click", function () { setActive(idx - 1); });
    if (next) next.addEventListener("click", function () { setActive(idx + 1); });
    var zoom = gallery.querySelector("[data-zoom]");
    if (zoom && main) {
      zoom.addEventListener("click", function () {
        var on = main.style.transform === "scale(1.8)";
        main.style.transform = on ? "" : "scale(1.8)";
        main.style.cursor = on ? "" : "zoom-out";
      });
    }
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("[data-qty-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = btn.dataset.qtyBtn === "up" ? 1 : -1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---- Variant selection: keep hidden id, price & button in sync ---- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var dataEl = form.querySelector("[data-variant-json]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idField = form.querySelector('select[name="id"], input[name="id"]');
    var priceEl = document.querySelector("[data-price]");
    var submitBtn = form.querySelector('[type="submit"]');
    var optionNames = (form.dataset.optionNames || "").split("|");

    function selectedValues() {
      return optionNames.map(function (name) {
        var checked = form.querySelector('input[name="options[' + name + ']"]:checked');
        return checked ? checked.value : null;
      });
    }
    function matchVariant(vals) {
      return variants.find(function (v) {
        return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
      });
    }
    function update() {
      var v = matchVariant(selectedValues());
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.innerHTML = v.priceHtml + (v.compareHtml ? ' <s class="price__compare">' + v.compareHtml + "</s>" : "");
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        var lbl = submitBtn.querySelector("[data-btn-label]");
        if (lbl) lbl.textContent = v.available ? (submitBtn.dataset.labelAvail || "Add to cart") : (submitBtn.dataset.labelSold || "Out of stock");
      }
    }
    form.querySelectorAll('input[type="radio"]').forEach(function (r) { r.addEventListener("change", update); });
  });

  /* ---- AJAX add-to-cart + live count ---- */
  function refreshCartCount() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "inline-flex" : "none";
      });
    }).catch(function () {});
  }
  document.querySelectorAll("[data-add-to-cart]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var html = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartCount();
          if (btn) { btn.textContent = "Added ✓"; setTimeout(function () { btn.innerHTML = html; btn.disabled = false; }, 1500); }
        })
        .catch(function () { if (btn) { btn.innerHTML = html; btn.disabled = false; } form.submit(); });
    });
  });
  refreshCartCount();
})();
